// extracted by mini-css-extract-plugin
export default {"wrapper":"Service_wrapper__P74lY","Service":"Service_Service__IxSb9","item-wp":"Service_item-wp__MWAZg"};